import React from 'react';
import './HomeMobile.css';

import { Grid } from '@mui/material';

import image1 from './assets/Box1.png';
import image2 from './assets/APEBNB.png';
import image3 from './assets/REKTY CLOWN.png';
import image4 from './assets/Newspaper.png';

import imageC1 from './assets/neww.png';
import imageC2 from './assets/Write Up Show.png';
import imageC3 from './assets/MILKIE.png';
import imageC4 from './assets/Kodas Eat.png';

import imageR1 from './assets/Cab.png';
import imageR2 from './assets/Monke.png';

import SystemMessage from './SystemMessage';
import Footer from '../Footer';
function App() {
  return (

    <div>
    <div className="containerz">
<Grid container spacing={2} className="grid-container">
                 <Grid item xs={6} md={6}>
  <img src={image1}  className="mobilenowimg"/>
    

                 </Grid>
    <Grid item xs={6} md={6}>

      <img src={image2}  className="mobilenowimg"/>
                 </Grid>
                 
</Grid>



<Grid container spacing={2} className="grid-container">
                 <Grid item xs={12} md={6}>
  <div className="padit">
            <SystemMessage />


       
   
        </div>
    

                 </Grid>
 
                 
</Grid>

  








<Grid container spacing={2} className="grid-container">
                 <Grid item xs={6} md={6}>
  <img src={imageC1}  className="mobilenowimg"/>
    

                 </Grid>
    <Grid item xs={6} md={6}>

      <img src={imageC2}  className="mobilenowimg"/>
                 </Grid>
                 
</Grid>


















<Grid container spacing={2} className="grid-container">
                 <Grid item xs={6} md={6}>
  <img src={imageC3}  className="mobilenowimg"/>
    

                 </Grid>
    <Grid item xs={6} md={6}>
 <img src={image4}  className="mobilenowimg"/>

                 </Grid>
                 
</Grid>





<Grid container spacing={2} className="grid-container">
                 <Grid item xs={6} md={6}>
  <img src={image3}  className="mobilenowimg"/>
    

                 </Grid>
    <Grid item xs={6} md={6}>

       <img src={imageR1}  className="mobilenowimg"/>
                 </Grid>
                 
</Grid>




<Grid container spacing={2} className="grid-container">
                 <Grid item xs={6} md={6}>
      <img src={imageR2}  className="mobilenowimg"/>
    

                 </Grid>
    <Grid item xs={6} md={6}>

       <img src={imageC4}  className="mobilenowimg"/>
                 </Grid>
                 
</Grid>



    </div>
          <br/>
<br/>
<br/>

      <Footer/>
    </div>

  );
}

export default App;
